var map = {
	"./du.svg": "5770",
	"./etisalat.svg": "6d1a",
	"./mobily.svg": "13e6",
	"./orange.svg": "8077",
	"./stc.svg": "678c",
	"./vodafone.svg": "a71a",
	"./we-telecom-egypt.svg": "8729",
	"./zain.svg": "39de"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "22d1";